module.exports = __webpack_public_path__ + "img/avatar.eabca385.png";